module.exports = __webpack_public_path__ + "img/ppt.44078eb9.png";